<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Subjective Evalution</span>
        </v-row>
                  <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <br />
        <div id="inspire">
        <!-- <v-app id="inspire" class> -->
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <center class="heading">
                <h3>Subjective Evalution</h3>
            </center>
            <div class="box">
                <v-form ref="form">
                    <v-row class="center">
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Select Exam</label>
                            <v-autocomplete
                                :items="exam_list"
                                item-text="exam"
                                v-model="exam"
                                :rules="[v => !!v || 'required']"
                                outlined
                                dense
                                placeholder="Select Exam"
                                class="select"
                                return-object
                            ></v-autocomplete>
                        </v-col>
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Select Subject</label>
                            <v-autocomplete
                                :items="crs_list"
                                item-text="course"
                                v-model="course"
                                :rules="[v => !!v || 'required']"
                                outlined
                                dense
                                placeholder="Select Course"
                                class="select"
                                return-object
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                </v-form>
                <div></div>
                <v-card-actions class="justify-center">
                    <v-btn class="mb-2 button btn" @click="proceed()" :loading="loading">Proceed</v-btn>
                </v-card-actions>
            </div>

            <template v-if="stud_data.length > 0">
  <v-card>
    <v-card-title>
        <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="stud_data"
      :search="search"
    >
    <template v-slot:item.action="{ item }">
      <v-btn color="info" @click="evaluateStud(item)">Evaluate</v-btn>
      </template>
    </v-data-table>
    
  </v-card>

</template>


</div>    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import datetime from "vuejs-datetimepicker";

    export default {
        components: { datetime },
        data: () => ({
            selected: [],
            evaluate:null,
            course:null,
            exam:null,
            exam_list:null,
            checked: [],
            stud_data:[],
            courseSrc: "",
            unitBlock: false,
            question_info: null,
            question_info_des: null,
            courseDes: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            crs_list: [],
            overlay:false,
            loading: false,
        search: '',
        headers: [
          { text: 'Sr No.', value: 'srno' },
          { text: 'Registration No', value: 'username' },
          { text: 'Student Name', value: 'name' },
          { text: 'Marks', value: 'marks' },
          { text: 'Action', value: 'action'}
        ],
        }),

        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                this.overlay = true
                axios
                    .post("/PaperChecker/getExamAndCourse")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.crs_list = res.data.courses;
                            this.exam_list = res.data.exams;
this.overlay = false
                        } else {
                            this.overlay = false
                        }
                    })
                    .catch((error) => {});
            },
evaluateStud(item){

let data = {
    exam:this.exam.exam,
    course:this.course.course,
    exam_id:this.exam.id,
    course_id:this.course.id,
    student_name: item.name,
    student_marks:item.marks,
    learner_id:item.learner_id,
    les:item.les
}

this.$router.push({ name: "subjective-checking" , params: { examData: data}});

},
            proceed() {
                this.loading = true;
                const data = {
                    exam: this.exam.id,
                    course: this.course.id,
                };
                    if (this.exam && this.course) {
                            axios
                                .post("/PaperChecker/getLesData", data)
                                .then((res) => {
                                    if (res.data.flag == "YES") {
                                        this.stud_data = res.data.stud_data;
                                        if(this.stud_data.length == 0)
                                        this.showSnackbar("#b71c1c", "Data not found!!");
                                    } else {
                                    }
                                    this.unitBlock = false;
                                })
                                .catch((error) => {})
                                .finally(() => {
                                    this.loading = false;
                                });
                    } else {
                        this.loading = false;
                        this.showSnackbar("#b71c1c", "Please select required fields!!");
                    
                }
            },

            getunit() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseSrc,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },

            getunitDes() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseDes,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info_des = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>

<style scoped>
    .unit {
        padding-left: 10rem;
    }
    .check {
        margin: 0px;
        padding: 0px 0px 0px 20px;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .downbtn {
        float: right;
    }
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .center {
        justify-content: center;
    }
    #inspire{
        border: 2px solid hsla(190, 99%, 30%, 1);
    }
</style>
